import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import CircleCheckFilled from '../../../../../../Cutesies/CircleCheckFilled';
import CircleCheckOutlined from '../../../../../../Cutesies/CircleCheckOutlined';
import { OfferingType, getFullNameForOfferingType } from '../../../../../Types';

const isUtilized = (offeringType: OfferingType, utilized: ReadonlyArray<OfferingType>) =>
  utilized.includes(offeringType);

interface Props {
  productLicenseOfferingTypes: ReadonlyArray<OfferingType>;
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>;
}

function OfferingTypeList({ productLicenseOfferingTypes, learningDesignOfferingTypes }: Props) {
  const offeringTypeListItems = productLicenseOfferingTypes.map((offeringType) => (
    <li className="flex flex-row mb-2" key={offeringType}>
      <div className="h-5 w-5 mr-2">
        {when(isUtilized(offeringType, learningDesignOfferingTypes), {})
          .map(() => <CircleCheckFilled />)
          .getOrElse(() => (
            <CircleCheckOutlined />
          ))}
      </div>
      {getFullNameForOfferingType(offeringType)}
    </li>
  ));
  return <ul>{offeringTypeListItems}</ul>;
}

export default observer(OfferingTypeList);
